import useTrans from "@/hooks/useTrans";
import { useApiContext } from "@/setup/flexbiz-api-provider";
import { setToStorage } from "@/utils/localStorage";
import styled from "@emotion/styled";
import { AiFillFacebook } from "@react-icons/all-files/ai/AiFillFacebook";
import { useRouter } from "next/router";
import Script from "next/script";
import React from "react";

const Btn = styled.button`
  width: 300px;
  height: 38px;
  padding: 12px;
  border: none;
  border-radius: 20px;
  opacity: 0.85;
  font-size: 17px;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;

  display: flex;
  align-items: center;

  background-color: #3b5998;
  color: white;

  &:hover {
    opacity: 1;
  }

  span {
    width: 100%;
    text-align: center;
  }
`;

export default function FbLogin() {
  const trans = useTrans();
  const context = useApiContext();
  const router = useRouter();
  const [status, setStatus] = React.useState(false);
  // const [facebookAuth, setFacebookAuth] = React.useState(null);
  // const [facebookProfile, setFacebookProfile] = React.useState(null);

  const goBack = () => {
    router.back();
    return null;
  };

  const permissionOptions = {
    scope: "public_profile,email",
    return_scopes: true,
  };

  React.useEffect(() => {
    // const script = document.createElement("script");
    // script.src =
    //   "https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v14.0&appId=654079745649186&autoLogAppEvents=1";
    // script.async = true;
    // script.nonce = "1341tSaz";
    // script.crossOrigin = "anonymous";
    // document.querySelector("body")?.appendChild(script);

    window.fbAsyncInit = function () {
      FB.init({
        appId: process.env.facebook_app_id,
        cookie: true,
        xfbml: true,
        version: "v14.0",
      });

      FB.AppEvents.logPageView();
      setStatus(true);
    };

    (function (d, s, id) {
      let js;
        const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/vi_VN/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  const createUser = async (data = {}) => {
    let urlToCreateProfile = `${process.env.server_url}/createUser/facebook?id_app=${process.env.id_app}&access_token=${data.accessToken}&group_id=${process.env.group_id}`;

    if (data.email)
      urlToCreateProfile += `&email=${data.email}`;
    if (data.password)
      urlToCreateProfile += `&password=${data.password}`;
    if (data.name)
      urlToCreateProfile += `&name=${data.name}`;

    const createdProfile = await context.apis.asyncGet(urlToCreateProfile);
    const creatdUserProfile = await context.apis.asyncGetUserInfoByToken(
      data.accessToken
    );
    // // console.log("🚀 ~ createUser ~ creatdUserProfile", creatdUserProfile);

    if (creatdUserProfile) {
      creatdUserProfile.token = data.accessToken;
      setToStorage("updateInfo", true);
      setToStorage("token", data.accessToken);
      goBack();
    }
  };

  const handleFacebookResponse = async (authResponse) => {
    try {
      // let userProfile = await getFacebookProfile(authResponse.accessToken);
      // // // console.log("🚀 ~ handleFacebookResponse ~ userProfile", userProfile);

      // if (!userProfile.registed) {
      //   setIsModalOpen(true);
      //   return;
      // }

      await createUser({
        accessToken: authResponse.accessToken,
        name: authResponse.displayName,
      });
    } catch (error) {
      console.log("error", error);
      console.error({
        message: "Lỗi handleFacebookResponse",
      });
    }
  };

  async function initFacebookLogin() {
    FB.init({
      appId: process.env.facebook_app_id,
      cookie: true,
      xfbml: true,
      version: "v14.0",
    });
    FB.getLoginStatus((res) => {
      if (res.authResponse) {
        // console.log("res.authResponse", res.authResponse);
        // setFacebookAuth(res.authResponse);
        handleFacebookResponse(res.authResponse);
        return;
      }

      FB.login((res) => {
        if (res.authResponse) {
          // console.log("res.authResponse", res.authResponse);
          // setFacebookAuth(res.authResponse);
          handleFacebookResponse(res.authResponse);
        }
      }, permissionOptions);
    });
  }
  return (
    <div>
      <Btn className="fb btn" onClick={initFacebookLogin}>
        <AiFillFacebook color="#fff" size={30} />
        <span>{trans?.login.loginFB}</span>
      </Btn>
      {/* {status && (
        <Btn className="fb btn" onClick={initFacebookLogin}>
          <AiFillFacebook color="#fff" size={30} />
          <span>Đăng nhập bằng Facebook</span>
        </Btn>
      )} */}
    </div>
  );
}
